import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 6,
  class: "step-body success"
}
const _hoisted_2 = {
  key: 0,
  class: "step-btns"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dialogue_modal = _resolveComponent("dialogue-modal")!
  const _component_Stepper = _resolveComponent("Stepper")!
  const _component_SchoolInfo = _resolveComponent("SchoolInfo")!
  const _component_FundingTerm = _resolveComponent("FundingTerm")!
  const _component_AmountRequest = _resolveComponent("AmountRequest")!
  const _component_ReviewRequest = _resolveComponent("ReviewRequest")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    class: "request-funds-modal",
    closeBtn: !_ctx.submitted,
    onClose: _ctx.closeModal
  }, {
    header: _withCtx(() => [
      (!_ctx.submitted)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[2] || (_cache[2] = _createElementVNode("p", null, "Request Funds", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "header-desc" }, " Submit a request for additional funds from your existing line of credit. ", -1))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      (_ctx.submitted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeDrawModal && _ctx.closeDrawModal(...args)), ["prevent"]))
            }, " Close ")
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (_ctx.showDialogueModal === true)
        ? (_openBlock(), _createBlock(_component_dialogue_modal, {
            key: 0,
            onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDialogueModal = false)),
            onConfirm: _ctx.handleDialogueModal,
            title: `Quit editing?`,
            msg: `Any changes you\'ve made so far will not be saved`,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
          }, null, 8, ["onConfirm"]))
        : _createCommentVNode("", true),
      (_ctx.activeStep < 4)
        ? (_openBlock(), _createBlock(_component_Stepper, {
            key: 1,
            steps: _ctx.steps,
            activeStep: _ctx.activeStep
          }, null, 8, ["steps", "activeStep"]))
        : _createCommentVNode("", true),
      (_ctx.activeStep === 1)
        ? (_openBlock(), _createBlock(_component_SchoolInfo, {
            key: 2,
            loan: _ctx.Loan,
            onClose: _ctx.cancelButton,
            onComplete: _ctx.schoolComplete
          }, null, 8, ["loan", "onClose", "onComplete"]))
        : (_ctx.activeStep === 2)
          ? (_openBlock(), _createBlock(_component_FundingTerm, {
              key: 3,
              onGoback: _ctx.goBack,
              onComplete: _ctx.fundingTermComplete
            }, null, 8, ["onGoback", "onComplete"]))
          : (_ctx.activeStep === 3)
            ? (_openBlock(), _createBlock(_component_AmountRequest, {
                key: 4,
                loan: _ctx.Loan,
                onGoback: _ctx.goBack,
                onComplete: _ctx.amountRequestComplete
              }, null, 8, ["loan", "onGoback", "onComplete"]))
            : (_ctx.activeStep === 4)
              ? (_openBlock(), _createBlock(_component_ReviewRequest, {
                  key: 5,
                  referenceId: _ctx.Loan?.referenceId,
                  onGoback: _ctx.goBack,
                  onComplete: _ctx.submitComplete
                }, null, 8, ["referenceId", "onGoback", "onComplete"]))
              : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("p", { class: "step-title" }, "Request Submitted!", -1),
                  _createElementVNode("p", { class: "step-desc" }, "Your request has been submitted successfully!", -1)
                ]))], 512)), [
                  [_vShow, _ctx.submitted]
                ])
    ]),
    _: 1
  }, 8, ["closeBtn", "onClose"]))
}